// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"395":"component---src-templates-page-template-js","532":"styles"}[chunkId] + "-" + {"395":"000d76aec4b1bfa9f4bd","532":"f2a7299418fea3d512d0"}[chunkId] + ".js";
};